<template lang="pug">
card
    .row
        .col-2.data-display
            span.data-title
                | N. Contrato
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.numeroContrato }}
        .col-2.data-display
            span.data-title
                | Cultura
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.materialNome }}
        .col-2.data-display
            span.data-title
                | Safra
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.safraNome }}
        .col-2.data-display
            span.data-title
                | Volume vendido (t)
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.volumeContratado }}
        .col-2.data-display
            span.data-title
                | Data do contrato
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.dataContrato }}
        .col-2.data-display
            span.data-title
                | Filial
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.fornecedorParceiroNome }}

    .row
        .col-2.data-display
            span.data-title
                | UF entrega
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.estadoSigla }}
        .col-2.data-display
            span.data-title
                | Município entrega
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.municipioNome }}
        .col-2.data-display
            span.data-title
                | CNPJ cliente
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.clienteCpfCnpj }}
        .col-2.data-display
            span.data-title
                | Cliente
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.clienteNomeRazaoSocial }}
        .col-2.data-display
            span.data-title
                | Status
            span.data-value
                | {{ this.payload.dadosContratoOriginacao.status }}
</template>

<script>
import Card from '@/components/Card';

export default {
    name: 'CardEmpresaVisualizarContratoAlvorada',
    components: {
        Card
    },

    props: {
        payload: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
#visualizar-contrato-originacao {
    .data-display {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;

        .data-title {
            font-size: 14px;
            margin-bottom: 8px;
            color: var(--primary);
            font-weight: 600;
        }

        .data-value {
            font-size: 14px;
            color: #636363;
        }
    }
}
</style>
